import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig, Validator } from "../../interface/field.interface";

@Component({
    selector: "form-field-input",
    templateUrl: './input.component.html'
})
export class InputComponent implements OnInit {
    field!: FieldConfig;
    group!: FormGroup;
    formName:string = '';
    ngOnInit() {
        this.isMandatory();
    }

    isMandatory(): string | null {
        if (this.field.validations && this.field.validations.length > 0) {
            let requiredValidator: Validator | undefined = this.field.validations.find(x => x.name == 'required')
            if (requiredValidator)
                return 'required';
        }
        return null;
    }
}
